var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row letter-bar" }, [
    _c(
      "div",
      { staticClass: "col-12 no-wrap scroll justify-around text-center" },
      _vm._l(_vm.availableLetters, function(letter) {
        return _c(
          "q-btn",
          {
            key: letter,
            staticClass: "self-center",
            attrs: {
              small: "",
              color: _vm.selectedLetters[letter] ? "info" : "grey-5",
              outline: _vm.selectedLetters[letter],
              flat: !_vm.selectedLetters[letter]
            },
            on: {
              click: function($event) {
                return _vm.handleLetter(letter)
              }
            }
          },
          [_vm._v("\n      " + _vm._s(letter) + "\n    ")]
        )
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }